import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Portal } from "react-overlays";
import { stringToDate } from "../../util";
import { range } from "lodash";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const RenderDatePicker = ({
  input,
  placeholder,
  className,
  startDate,
  minDate,
  disabled,
}) => {
  // if (!startDate) return null;

  const years = range(1900, new Date().getFullYear() + 1, 1);
  const months = [
    "Tháng 1",
    "Tháng 2",
    "Tháng 3",
    "Tháng 4",
    "Tháng 5",
    "Tháng 6",
    "Tháng 7",
    "Tháng 8",
    "Tháng 9",
    "Tháng 10",
    "Tháng 11",
    "Tháng 12",
  ];

  return (
    <DatePicker
      {...input}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            margin: 10,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            className="btn px-2 py-0"
          >
            {"<"}
          </button>
          <select
            value={date.getFullYear()}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[date.getMonth()]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            className="btn px-2 py-0"
          >
            {">"}
          </button>
        </div>
      )}
      className={className || ""}
      selected={
        input.value
          ? stringToDate(input.value, "dmy")
          : stringToDate(startDate, "dmy")
      }
      dateFormat="dd/MM/yyyy"
      onChange={(date) => {
        date && input.onChange(moment(date).format("DD/MM/YYYY"));
      }}
      selectsStart
      // startDate={stringToDate(startDate, 'dmy')}
      // endDate={stringToDate(endDate, 'dmy')}
      placeholder={placeholder || "Nhập ngày"}
      minDate={minDate || null}
      popperContainer={CalendarContainer}
      disabled={disabled}
    />
  );
};

export default RenderDatePicker;
